import { useState } from 'react';
import { SelectedEntities, ItemType } from 'shared/types/portfolios';
import { DatatableItemsData } from 'ui/Datatable/Datatable';

export const useSelectedTableRows = (type = ItemType.SCOPEONEID) => {
  const [selectedAll, setSelectedAll] = useState(false);

  const [multiSelect, setMultiSelect] = useState<SelectedEntities>({
    count: 0,
    itemIds: {},
    items: {},
    type,
  });

  const [singleSelect, setSingleSelect] = useState<SelectedEntities>({
    count: 0,
    itemIds: {},
    items: {},
    type,
  });

  const currentSelect = singleSelect.count === 1 ? singleSelect : multiSelect;

  const onSelectedChange = (items: DatatableItemsData) => {
    // @ts-ignore
    setMultiSelect(prev => ({ ...prev, ...items }));

    setSelectedAll(false);
  };

  const clearSingle = () =>
    setSingleSelect({
      count: 0,
      itemIds: {},
      items: {},
      type,
    });

  const onSelectAll = () => setSelectedAll(all => !all);

  const selectSingle = (id: string, artifactId: string = '') =>
    setSingleSelect({
      count: 1,
      itemIds: { [id]: id },
      items: artifactId ? { [id]: [[id, artifactId]] } : {},
      type,
    });

  return {
    /* item selected by dots button for single row */
    singleSelect,
    /* items selected with checkboxes */
    multiSelect,
    /* singleSelect if present, multiSelect otherwise */
    currentSelect,
    selectedAll,
    selectSingle,
    clearSingle,
    onSelectedChange,
    onSelectAll,
  };
};
